
import { FlyerArrow } from './arrow/FlyerArrow'

import './FlyerPagesArrows.scss'

interface IFlyerArrows {
    onLeftArrowClick: () => void;
    onNextArrowClick: () => void;
    pageIndex: number;
    totalPages: number;
}

export const FlyerPagesArrows: React.FC<IFlyerArrows> = (props) => {

    const isDisabled = (arrowType: string) => {
        if(arrowType === 'left'){
            let disabled = false;

            if(props.pageIndex === 0){
                disabled = true;
            }
            return disabled;
        } else {
            let disabled = false;

            if(props.pageIndex === props.totalPages - 1){
                disabled = true;
            }
            return disabled;
        }
    }

    return (
        <div className="flyers_arrows_container">
            
            <FlyerArrow
                arrowType='left'
                disabled={isDisabled('left')}
                onClick={props.onLeftArrowClick}
            />

            <FlyerArrow
                arrowType='right'
                disabled={isDisabled('right')}
                onClick={props.onNextArrowClick}
            />
        </div>
    )
}